import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { getClingenData } from "../../../../state/selectors/ClinGen.selectors";
import { DEFAULT_COLOR } from "../../../../common/helpers/helpers";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";

const GeneClingenCard = ({ card, clingenData }) => {
  const isDisabled = !Object.keys(clingenData || {}).length;
  let color = DEFAULT_COLOR;
  if (
    Object.keys(clingenData || {}).length &&
    (clingenData.triplosensitivity_score !== 0 ||
      clingenData.haploinsufficiency_score !== 0)
  ) {
    color = getPathogenicityColorByAllNames("Likely Pathogenic");
  }

  return (
    <CardWrapper {...card} isDisabled={isDisabled} color={color}>
      <div>
        {`Haploinsufficiency score: `}
        <span
          data-testid="cligen-gene-card-haploinsufficiency-score"
          className="tw-font-bold"
        >
          {clingenData?.haploinsufficiency_score}
        </span>
      </div>
      <div>
        {`Triplosensitivity score: `}
        <span
          data-testid="cligen-gene-card-triplosensitivity-score"
          className="tw-font-bold"
        >
          {clingenData?.triplosensitivity_score}
        </span>
      </div>
    </CardWrapper>
  );
};

GeneClingenCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  clingenData: PropTypes.shape({
    clingen_gene_id: PropTypes.number,
    haploinsufficiency_desc: PropTypes.string,
    haploinsufficiency_score: PropTypes.number,
    pub_med_references: PropTypes.arrayOf(PropTypes.number),
    triplosensitivity_desc: PropTypes.string,
    triplosensitivity_score: PropTypes.number,
    version: PropTypes.string,
  }),
};

GeneClingenCard.defaultProps = {
  clingenData: {},
};

const mapStateToProps = (state) => ({
  clingenData: getClingenData(state),
});

export default connect(mapStateToProps, {})(GeneClingenCard);
